@use "../../sass/variables/colors";

@use "sass:color";

:host {
  position: relative;
  display: block;
}

.ux-video {
  &__play-button {
    background-color: color.adjust(colors.$color-white, $alpha: -0.3);
    border: 0;
    border-radius: 40px;
    cursor: pointer;
    height: 80px;
    left: 50%;
    margin: auto;
    position: absolute;
    text-align: center;
    top: 50%;
    transform: translate(-50%, -50%);
    transition: all 500ms ease;
    width: 80px;
    z-index: 1;

    @media only screen and (width <= 767px) {
      height: 60px;
      top: 47%;
      width: 60px;
    }

    @media only screen and (width <= 567px) {
      height: 48px;
      top: 48%;
      width: 48px;
    }

    &:hover {
      background-color: color.adjust(colors.$color-white, $alpha: -0.3);
    }

    &--inactive {
      opacity: 0;
      pointer-events: none;
    }
  }

  &__play-button--controls-active {
    transition-delay: top 500ms;

    @media only screen and (width <= 567px) {
      top: 40%;
    }
  }

  &__play-icon {
    fill: colors.$color-black;
    font-size: 26px;
    left: calc(50% + 3px);
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);

    @media only screen and (width <= 767px) {
      font-size: 22px;
    }

    @media only screen and (width <= 567px) {
      font-size: 18px;
      left: calc(50% + 2px);
    }
  }

  &__play-icon[name="reset"] {
    font-size: 24px;
    left: 50%;
    top: 51%;

    @media only screen and (width >= 568px) {
      font-size: 30px;
    }

    @media only screen and (width >= 768px) {
      font-size: 35px;
    }
  }
}


::slotted(video) {
  display: block;
  max-width: 100%;
  width: 100%;

  &:focus {
    outline: none;
  }

  &::-webkit-media-controls-overlay-play-button {
    opacity: 0;
  }
}
